module.exports = __webpack_public_path__ + "img/financial-pure-risk-component.0886cc60.jpg";